import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getFormValues } from "redux-form";

import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import Button from "../common/button/button";
import Form from "./gestorConcessionariaForm";
import FormVincularGestorUnidade from "./vincularGestorConcessionariaUnidadesForm";
import { getListaConcessionariaEnergia, getListaConcessionariaAgua, getListaTipoConcessionaria } from "../concessionaria/concessionariaActions";
import { getListaGrupoFaturamento, getListaClienteSelect } from "../cliente/clienteActions";
import { setModoTela, initForm, salvar, excluir, getLista, vincularGestorConcessionariaNasUnidades, getGestorConcessionariaSelect } from "./gestorConcessionariaActions";
import { Loading } from "../common/loading/loading";
import FormatUtils from "../common/formatUtils/FormatUtils";

class GestorConcessionaria extends Component {
    componentWillMount() {
        this.props.getListaGrupoFaturamento();
        this.props.getListaClienteSelect();
        this.props.getGestorConcessionariaSelect();
        this.props.getListaConcessionariaEnergia();
        this.props.getListaConcessionariaAgua();
        this.props.getListaTipoConcessionaria();
        this.props.getLista();
    }

    render() {
        //Sem acesso
        if (!this.props.usuarioLogado || this.props.usuarioLogado.acesso_cliente) {
            return <div />;
        }

        return (
            <div>
                {this.props.aguardando ? <Loading /> : null}

                <Content>
                    {this.props.modoTela === "visualizacao" ? <Form visualizar onSubmit={() => {}} /> : null}
                    {this.props.modoTela === "cadastro" ? <Form onSubmit={this.props.salvar} /> : null}
                    {this.props.modoTela === "vincular_gestor_unidade" ? (
                        <FormVincularGestorUnidade vincularGestorConcessionariaNasUnidades={this.props.vincularGestorConcessionariaNasUnidades} />
                    ) : null}
                    {this.props.modoTela === "exclusao" ? <Form excluir onSubmit={this.props.excluir} /> : null}
                    {this.props.modoTela === "lista" ? this.lista() : null}
                </Content>
            </div>
        );
    }

    lista() {
        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <Grid cols="12 6 4 2">
                            <Button
                                text="Adicionar"
                                type={"success"}
                                icon={"fa fa-plus"}
                                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/gestorConcessionaria.js (incluir) e no endpoint POST /api/gestor-concessionaria
                                disabled={!this.props.usuarioLogado.acesso_gestor_concessionaria_adicionar}
                                event={() => {
                                    this.props.setModoTela("cadastro", {});
                                    this.props.initForm({});
                                }}
                            />
                        </Grid>
                        <Grid cols="12 6 4 3">
                            <Button
                                text="Vincular Gestor às Unidades"
                                type={"primary"}
                                icon={"fa fa-id-card-alt"}
                                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/gestorConcessionaria.js (vincularUnidades) e no endpoint PUT /api/gestor-concessionaria/vincular-unidades
                                disabled={!this.props.usuarioLogado.acesso_gestor_concessionaria_vincular}
                                event={() => {
                                    this.props.setModoTela("vincular_gestor_unidade", {});
                                }}
                            />
                        </Grid>
                    </Row>
                </ContentCardHeader>
                <ContentCardBody>
                    <Table responsive>
                        <THead>
                            <NewTr backgroundColorTr={"#FFFFFF"} backgroundColorTd={"#F5F5F5"}>
                                <Th sticky>Nome</Th>
                                <Th sticky>Telefone</Th>
                                <Th sticky>E-mail</Th>
                                <Th sticky>Tipo de Concessionária</Th>
                                <Th sticky>Nome da Concessionária</Th>
                            </NewTr>
                        </THead>
                        <TBody>
                            {this.props.lista.map((item) => {
                                const registro = { ...item };
                                return (
                                    <NewTr
                                        key={item.id}
                                        backgroundColorTr={"#FFFFFF"}
                                        backgroundColorTd={"#F5F5F5"}
                                        botoes={[
                                            {
                                                type: "primary",
                                                icon: "fas fa-eye",
                                                disabled: !this.props.usuarioLogado.acesso_gestor_concessionaria_visualizar,
                                                event: () => {
                                                    this.props.setModoTela("visualizacao", registro);
                                                    this.props.initForm(registro);
                                                },
                                            },
                                            {
                                                type: "warning",
                                                icon: "fas fa-pencil-alt",
                                                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/gestorConcessionaria.js (editar) e no endpoint PUT /api/gestor-concessionaria
                                                disabled: !this.props.usuarioLogado.acesso_gestor_concessionaria_editar,
                                                event: () => {
                                                    this.props.setModoTela("cadastro", registro);
                                                    this.props.initForm(registro);
                                                },
                                            },
                                            {
                                                type: "danger",
                                                icon: "fas fa-trash-alt",
                                                // REGRA DE PERMISSÃO REFLETIDA EM backend/app/domain/permissao/gestorConcessionaria.js (excluir) e no endpoint DELETE /api/gestor-concessionaria
                                                disabled: !this.props.usuarioLogado.acesso_gestor_concessionaria_excluir,
                                                event: () => {
                                                    this.props.setModoTela("exclusao", registro);
                                                    this.props.initForm(registro);
                                                },
                                            },
                                        ]}
                                    >
                                        <Td minWidth={150}>{item.nome}</Td>
                                        <Td>{FormatUtils.formatarTelefone(item.telefone || "")}</Td>
                                        <Td>{item.email}</Td>
                                        <Td>{item.tipo_concessionaria}</Td>
                                        <Td>{item.tipo_concessionaria === "ENERGIA" ? item.nome_concessionaria_energia : item.nome_concessionaria_agua}</Td>
                                    </NewTr>
                                );
                            })}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }
}

const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    modoTela: state.gestorConcessionaria.modoTela,
    formularioValues: getFormValues("gestorConcessionariaForm")(state),
    aguardando: state.gestorConcessionaria.aguardando,
    filtro: state.gestorConcessionaria.filtro,
    lista: state.gestorConcessionaria.lista,
    listaConcessionariaEnergiaSelect: state.concessionaria.listaConcessionariaEnergiaSelect,
    listaConcessionariaAguaSelect: state.concessionaria.listaConcessionariaAguaSelect,
    listaTipoConcessionaria: state.concessionaria.listaTipoConcessionaria,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            salvar,
            excluir,
            getLista,
            getListaConcessionariaEnergia,
            getListaConcessionariaAgua,
            getListaTipoConcessionaria,
            vincularGestorConcessionariaNasUnidades,
            getGestorConcessionariaSelect,
            getListaGrupoFaturamento,
            getListaClienteSelect,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(GestorConcessionaria);
